import { HEADER_HEIGHT } from 'constants/layout'
import React from 'react'
import styled, { css } from 'styled-components'
import { FittedImage } from 'uiComponents/atoms/FittedImage'

const FullScreenTeaser = styled.div<Partial<ITeaserProps>>`
  height: ${({ largeTeaser }) =>
    largeTeaser ? `100vh` : `calc(100vh - ${HEADER_HEIGHT}px)`};
  width: 100%;
  min-height: 200px;
  position: relative;
`

const Teaser = styled.div`
  height: ${(371 / 1440) * 100}vw;
  width: 100%;
  position: relative;
`

const TeaserOverlay = styled.div<Partial<ITeaserProps>>`
  height: 100%;
  width: 100%;
  position: absolute;
  ${({ largeTeaser }) =>
    css`
      background-image: ${largeTeaser
        ? `linear-gradient(
          to bottom,
          rgba(0, 0, 0, .55),
          rgba(0,0, 0, .2),
          rgba(0, 0, 0, .55)
        )`
        : `linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.35),
          rgba(0, 0, 0, 0.25),
          rgba(0, 0, 0, 0.35)
        )`};
    `};
`

const TeaserBackground = styled(FittedImage)<Partial<IImageProps>>`
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
`

interface ITeaserProps {
  className?: string
  largeTeaser?: boolean
  disableOverlay?: boolean
}

interface IImageProps {
  src: string
  alt?: string
  fullscreen: boolean
}

interface IProps extends ITeaserProps, IImageProps {}

const PageHeaderImageTeaser: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    src,
    children,
    className,
    alt,
    largeTeaser = false,
    fullscreen,
    disableOverlay = false,
  } = props

  const childrenWithOverlayMaybe = disableOverlay ? (
    children
  ) : (
    <TeaserOverlay data-testid="TeaserOverlay" largeTeaser={largeTeaser}>
      {children}
    </TeaserOverlay>
  )

  if (fullscreen) {
    return (
      <FullScreenTeaser
        className={className}
        largeTeaser={largeTeaser}
        data-testid="FullscreenImageTeaser"
      >
        {childrenWithOverlayMaybe}
        <TeaserBackground src={src} alt={alt} />
      </FullScreenTeaser>
    )
  }

  return (
    <Teaser className={className} data-testid="LargeScreenImageTeaser">
      {childrenWithOverlayMaybe}
      <TeaserBackground src={src} alt={alt} />
    </Teaser>
  )
}

export default PageHeaderImageTeaser
